import React from "react";
import "./EndingBodyMobile.css";

const EndingBodyMobile = () => {
    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: "center",
                    flexFlow: "wrap",
                }}
            >
                <h2
                    className="blue-ending-rectangle font-face-poppins-bold"
                    style={{ fontSize: "35px" }}
                >
                    ¡Gracias por
                </h2>
                <h2
                    className="blue-font font-face-poppins-bold"
                    style={{
                        fontSize: "35px",
                        marginLeft: "10px",
                    }}
                >
                    completar
                </h2>
                <h2
                    className="blue-ending-rectangle font-face-poppins-bold"
                    style={{
                        fontSize: "35px",
                        marginLeft: "10px",
                    }}
                >
                    la solicitud!
                </h2>
            </div>
        </React.Fragment>
    );
};

export default EndingBodyMobile;
